jQuery(document).ready(function($) {
    $('.load-more-link').on('click', function(event) {
        event.preventDefault();
        var obj = $(this);
        var post_type = obj.data('post-type');
        var tax = obj.data('tax');
        var term = obj.data('term');
        var offset = obj.data('offset');
        var grid = obj.data('grid');
        var count = obj.data('count');
        if (typeof post_type != undefined) {
            $.ajax({
                url: Ajax.url,
                type: 'GET',
                data: {
                    action: 'get_posts',
                    post_type: post_type,
                    tax: tax,
                    term: term,
                    offset: offset,
                    grid: grid,
                    count: count,
                },
                success: function(data) {
                    $('.spinner').hide();
                    if (data == 0) {
                        obj.hide();
                    } else {
                        if (isNaN(count)) {
                            var new_offset = offset + 3;
                        } else {
                            var new_offset = offset + count;
                        }
                        obj.data('offset', new_offset);
                        obj.parent().before(data);
                        obj.parent().prev().find('img').imgpreload({
                            each: function() {
                                obj.parent().prev().find('a').av_heights();
                            }
                        });
                    }
                    //obj.parent().prev().find('a').av_heights();
                },
                beforeSend: function() {
                    $('.spinner').show();
                }
            });
            return false;
        }
    });

    $('select[name=mcat]').on('change', function(ev) {
        var obj = $(this);
        var optionSelected = $("option:selected", obj);
        var parentId = optionSelected.data('cat-id');
        if (!isNaN(parentId)) {
            $.ajax({
                url: Ajax.url,
                type: 'GET',
                data: {
                    action: 'get_material_category_options',
                    parentid: parentId,
                },
                success: function(data) {
                    $('select[name=mter]').empty().append(data);
                    $('select[name=mter]').focus();
                },
            });
        } else {
            var option = '<option data-cat-id="" value="">Seleccionar</option>';
            $('select[name=mter]').empty().append(option);
            $('select[name=mter]').focus();
        }
        return false;
    });
});